import { render, staticRenderFns } from "./EditStandardisedJob.vue?vue&type=template&id=9b0b9fc6&scoped=true"
import script from "./EditStandardisedJob.vue?vue&type=script&lang=ts"
export * from "./EditStandardisedJob.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0b9fc6",
  null
  
)

export default component.exports